import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { SelectStyle } from './style';

export default function SelectEdit({ setCompaniesName, setCompaniesId, companiesName }) {
  const { company } = useSelector((state) => state.searchCompany);
  const [selectValue, setSelectValue] = useState('0');
  const [newCompanyId, setNewCompanyId] = useState({});
  const [newCompanyName, setNewCompanyName] = useState({});

  const handleCompany = () => {
    let companySelect = {
      companyId: {
        _id: newCompanyId,
        name: newCompanyName,
      },
    };
    let duplicateCompany = false;
    companiesName.forEach((compName) => {
      if (compName.name === companySelect.companyId.name) {
        duplicateCompany = true;
      }
    });
    if (!duplicateCompany) {
      setCompaniesName((e) => [...e, { name: companySelect.companyId.name }]);
      setCompaniesId((e) => [...e, { companyId: companySelect.companyId._id }]);
    }
  };

  const selectCompany = (e) => {
    setSelectValue(e.target.value);
    const value = e.target.value;
    const arrayValue = value.split(',');
    setNewCompanyId(arrayValue[0]);
    setNewCompanyName(arrayValue[1]);
  };

  return (
    <SelectStyle>
      <label>Empresa</label>
      <div>
        <select name="selectCompany" onChange={selectCompany}>
          <option value="0">Selecione a empresa</option>
          {company &&
            company.map((comp, index) => (
              <option key={index + 1} value={[comp._id, comp.name]}>
                {comp.name}
              </option>
            ))}
        </select>
        <button onClick={handleCompany} disabled={selectValue === '0' ? true : false}>
          Adicionar empresa
        </button>
      </div>
    </SelectStyle>
  );
}
